import React from "react";

const ErrorMsg = ({ isServerErr }) => {
  return (
    <div className="errMsg">
      <div>
        {isServerErr.failedRes !== "" && isServerErr.failedRes !== undefined && (
          <div className="statusSection block-red">
            <p>{isServerErr.failedRes}</p>
          </div>
        )}
        {isServerErr.limitExceeded !== "" &&
          isServerErr.limitExceeded !== undefined && (
            <div className="statusSection block-orange">
              <p>{isServerErr.limitExceeded}</p>
            </div>
          )}
        {isServerErr.successRes !== "" && isServerErr.successRes !== undefined && (
          <div className="statusSection block-success">
            <p>{isServerErr.successRes}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorMsg;
